import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Calendar, MapPin } from 'lucide-react';
import { toast } from 'sonner';
import { HtmlContent } from '../components/RichTextEditor';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Etkinlikler() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/events`);
      const data = await response.json();
      setEvents(data);
    } catch (error) {
      toast.error('Etkinlikler yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white flex items-center justify-center">
        <div className="text-xl text-amber-800">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 fade-in">
          <h1 className="text-4xl sm:text-5xl font-bold text-amber-900 mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
            Etkinlikler
          </h1>
          <p className="text-lg text-amber-700">
            Yakında gerçekleşecek ve geçmiş etkinliklerimiz
          </p>
        </div>

        {events.length === 0 ? (
          <Card className="border-2 border-amber-200 bg-white">
            <CardContent className="p-12 text-center">
              <p className="text-lg text-amber-700">Henüz etkinlik yayınlanmamış</p>
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {events.map((item) => (
              <Card key={item.id} className="card-hover border-2 border-amber-200 bg-white" data-testid={`event-card-${item.id}`}>
                <CardHeader className="bg-gradient-to-r from-amber-100 to-orange-100">
                  <CardTitle className="text-amber-900 text-2xl" style={{ fontFamily: 'Merriweather, serif' }}>
                    {item.title}
                  </CardTitle>
                  <div className="space-y-2 mt-3">
                    <div className="flex items-center gap-2 text-amber-700">
                      <Calendar className="w-4 h-4" />
                      <span className="text-sm font-semibold">{formatDate(item.date)}</span>
                    </div>
                    <div className="flex items-center gap-2 text-amber-700">
                      <MapPin className="w-4 h-4" />
                      <span className="text-sm font-semibold">{item.location}</span>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="pt-6">
                  <HtmlContent html={item.description} className="text-amber-800 leading-relaxed" />
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
